import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import OutdoorDining from "../../components/icons/NavIcons/OutdoorDining";
import Cafe from "../../components/icons/NavIcons/Cafe";
import ShippingAndReceiving from "../../components/icons/NavIcons/ShippingAndReceiving";
import Offices from "../../components/icons/NavIcons/Offices";
import PatientRoom from "../../components/icons/NavIcons/PatientRoom";
import NurseStation from "../../components/icons/NavIcons/NurseStation";
import GiftShop from "../../components/icons/NavIcons/GiftShop";
import CoffeeShop from "../../components/icons/NavIcons/CoffeeShop";

const HealthcarePage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash healthcarePage">
        <Header />
        <div className="page-header">Healthcare Dining</div>
        <div className="text-blocks">
          <div className="std-text">
            Empower preference-driven dining with 
            safe, efficient options tailored to 
            patients, staff and visitors.{'\n\n'}
            Modern hospital food service systems enable 
            dietary compliance, allergen tracking, and flexible 
            ordering channels, from bedside meal selection to 
            mobile ordering for clinicians.{'\n\n'}
            By integrating secure payments and streamlining 
            workflows, they reduce waste, improve staff 
            productivity, and ensure every meal supports 
            patient recovery, staff efficiency, and visitor 
            convenience.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Healthcare", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="business-industry-map">
          <div className="outdoor-dining">
            <OutdoorDining 
              onClick={() => {
                _logEvent("click", "Healthcare", "Outdoor Dining");
                addFlow("Outdoor Dining");
                navigate("outdoor-dining", { relative: "path" });
              }}
            />
          </div>
          <div className="offices">
            <Offices
              onClick={() => {
                _logEvent("click", "Healthcare", "Offices");
                addFlow("Offices");
                navigate("offices", { relative: "path" });
              }}
            />
          </div>
          <div className="patient-room">
            <PatientRoom
              onClick={() => {
                _logEvent("click", "Healthcare", "Patient Room");
                addFlow("Patient Room");
                navigate("patient-room", { relative: "path" });
              }}
            />
          </div>
          <div className="nurse-station">
            <NurseStation 
              onClick={() => {
                _logEvent("click", "Healthcare", "Nurse Station");
                addFlow("Nurse Station");
                navigate("nurse-station", { relative: "path" });
              }}
            />
          </div>
          <div className="cafe">
            <Cafe 
              onClick={() => {
                _logEvent("click", "Healthcare", "Cafe");
                addFlow("Cafe");
                navigate("cafe", { relative: "path" });
              }}
            />
          </div>
          <div className="gift-shop">
            <GiftShop 
              onClick={() => {
                _logEvent("click", "Healthcare", "Gift Shop");
                addFlow("Gift Shop");
                navigate("gift-shop", { relative: "path" });
              }}
            />
          </div>
          <div className="kitchen">
            <Kitchen
              onClick={() => {
                _logEvent("click", "Healthcare", "Kitchen");
                addFlow("Kitchen");
                navigate("kitchen", { relative: "path" });
              }}
            />
          </div>
          <div className="coffee-shop">
            <CoffeeShop 
              onClick={() => {
                _logEvent("click", "Healthcare", "Coffee Shop");
                addFlow("Coffee Shop");
                navigate("coffee-shop", { relative: "path" });
              }}
            />
          </div>
          <div className="shipping-and-receiving">
            <ShippingAndReceiving
              onClick={() => {
                _logEvent("click", "Healthcare", "Shipping & Receiving");
                addFlow("Shipping & Receiving");
                navigate("shipping", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default HealthcarePage;